import { useFetchWrapper } from "../hooks/useFetchWrapper";
import {useLoading} from "../utils/LoadingContext";
import { notifyError, formatAPIErrorLog, formatAPIResponseLog } from "../utils/helpers";
import { SUPPORT_REQUEST_ERROR } from "../utils/toast-message-constants";
import {useConfig} from "../hooks/useConfig";
const defaultInstitutionId = "b6f0e9d1-1844-4c7c-9b7c-9588e3cb6615";

export const PublicApiCall = () => {
    const fetchWrapper = useFetchWrapper();
    const config = useConfig();

    const {setLoading} = useLoading();

    return {
        resolveShortName,
        checkPollInCourse,
        supportRequest,
        getInstitutionDetails,
        postPPTMessage,
        listEventBanners,
    }

    // Function that handles login
    // Does not return any data, sets all the session data in the function
    function resolveShortName(shortName) {

        // set user in local storage, and go back to the previous page
        return fetchWrapper.get(
            {
                url: `${config.api.public}/public/inst?shortName=${shortName}`,
                authorizeRequired: false
            }
        ).then(res => {
            if (res.success) {
                return res.result;
            }
        }).catch(err => {
            console.log(err);
            return {institutionId: defaultInstitutionId};
        });
    }

    function checkPollInCourse(pollCode) {
        setLoading(true);
        return fetchWrapper.get(
            {
                url: `${config.api.public}/public/poll/${pollCode}/course`,
                authorizeRequired: false
            }
        ).then(res => {
            if (res.success) {
                formatAPIResponseLog("CheckPollInCourse", res.result);
                return res.result;
            }
        }).catch(err => {
            console.log(err);
            formatAPIErrorLog("CheckPollInCourse", err);
            return false;
        }).finally(() => {
            setLoading(false);
        });
    }

    function supportRequest(name, email, subject, message) {
        return fetchWrapper.post(
            {
                url: `${config.api.public}/public/support`,
                body: {
                    "name": name ,
                    "email": email,
                    "subject": subject,
                    "message": message
                }
            }
        ).then(res => {
            if (!res.success) {
                notifyError(SUPPORT_REQUEST_ERROR);
            }
            return res.result;
        }).catch(err => {
            console.log(err);
            return false;
        });
    }

    function getInstitutionDetails(shortname) {
        return fetchWrapper.get({
            url: `${config.api.public}/public/inst?shortName=${shortname}`,
            authorizeRequired: false
        }).then((res) => {
            if (res.success) {
                return res.result;
            }
        }).catch(error => {
            console.log(error);
        });
    }

    // Function to post message to PPT websocket connection
    function postPPTMessage(appId, content) {
        const bodyObj = {content};

        return fetchWrapper.post({
            url:  `${config.api.public}/public/ppt/${appId}/message`,
            body: bodyObj,
            authorizeRequired: false
        }).catch((error) => {
            console.log(error);
        });
    }

    function listEventBanners() {
        return fetchWrapper.get({url: `${config.api.public}/public/eventBanners`})
            .then((res) => {
                    if (res.success) {
                        return res.result.map(b => {
                            b.institutions = !!b.institutions ? b.institutions : [];
                            return b;
                        });
                    } else {
                        notifyError(res.errorMessage);
                        return [];
                    }
                },
                (error) => {
                    console.log(error);
                    return [];
                });
    }
}
